import { render, staticRenderFns } from "./Atleti.vue?vue&type=template&id=e7e4cbf8"
import script from "./Atleti.vue?vue&type=script&lang=js"
export * from "./Atleti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports